import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=593c72b4&scoped=true"
import script from "./Persona.vue?vue&type=script&lang=js"
export * from "./Persona.vue?vue&type=script&lang=js"
import style0 from "./Persona.vue?vue&type=style&index=0&id=593c72b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593c72b4",
  null
  
)

export default component.exports